import { setUser } from "@store/authSlice";
import { persistor } from "@store/store";
import { AuthService } from "@service/auth.service";
import { NotificationService } from "@service/notification.service";
import { MobileService } from "@service/mobile.service";
import { INTRO_SEEN_STORAGE_KEY } from "@constants/intro";
import { Dispatch } from "redux";

const authService = AuthService.instance;
const notificationService = NotificationService.instance;
const mobileService = MobileService.instance;

const selectiveLocalStorageClear = (keysToKeep: string[]) => {
  const keep = new Set(keysToKeep);
  // Iterate backwards because removing items shifts indices.
  for (let i = localStorage.length - 1; i >= 0; i--) {
    const key = localStorage.key(i);
    if (!key) continue;
    if (!keep.has(key)) {
      localStorage.removeItem(key);
    }
  }
};

export class SignOutService {
  public static instance = new SignOutService();

  private constructor() {}

  async signOut(dispatch: Dispatch): Promise<void> {
    await notificationService.unsubscribeAll();

    // Delete server-side push token association *before* invalidating auth.
    try {
      const cachedJson = localStorage.getItem(
        MobileService.PUSH_TOKEN_CACHE_KEY,
      );
      if (cachedJson) {
        const cached = JSON.parse(cachedJson) as { token?: string };
        const token = cached.token;
        if (token) {
          await mobileService.deletePushToken(token);
        }
      }
    } catch {
      // Best-effort: if we can't delete, still sign out.
    }

    await authService.signOut();
    dispatch(setUser(null));
    await persistor.purge();
    // Keep only the intro-seen flag + the push-token payload cache.
    selectiveLocalStorageClear([
      INTRO_SEEN_STORAGE_KEY,
      MobileService.PUSH_TOKEN_CACHE_KEY,
    ]);
    window.location.href = "/";
  }
}
